// src/slices/category/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getAllCategories, getCategoryById, getCategoryBySlug } from "./thunk";

const initialState = { category: [], singleCategory: null, loading: false, error: null };

const categorySlice = createSlice({
  name: "category",
  initialState,

  reducers: {
    clearCategory(state) {
      state.singleCategory = null;
    }
  },

  extraReducers: (builder) => {
    builder

      // ================= GET ALL =================
      .addCase(getAllCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload?.data || action.payload;
      })
      .addCase(getAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY ID =================
      .addCase(getCategoryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCategoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.singleCategory = action.payload?.data || action.payload;
      })
      .addCase(getCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY SLUG =================
      .addCase(getCategoryBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCategoryBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.singleCategory = action.payload?.data || action.payload;
      })
      .addCase(getCategoryBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearCategory } = categorySlice.actions;
export default categorySlice.reducer;
